var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGestaoEmpresarial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 55V13.75C96.25 6.1875 90.0625 0 82.5 0H41.25C33.6875 0 27.5 6.1875 27.5 13.75V27.5H13.75C6.1875 27.5 0 33.6875 0 41.25V110C0 117.562 6.1875 123.75 13.75 123.75H48.125C51.9062 123.75 55 120.656 55 116.875V96.25H68.75V116.875C68.75 120.656 71.8438 123.75 75.625 123.75H110C117.562 123.75 123.75 117.562 123.75 110V68.75C123.75 61.1875 117.562 55 110 55H96.25ZM27.5 110H13.75V96.25H27.5V110ZM27.5 82.5H13.75V68.75H27.5V82.5ZM27.5 55H13.75V41.25H27.5V55ZM55 82.5H41.25V68.75H55V82.5ZM55 55H41.25V41.25H55V55ZM55 27.5H41.25V13.75H55V27.5ZM82.5 82.5H68.75V68.75H82.5V82.5ZM82.5 55H68.75V41.25H82.5V55ZM82.5 27.5H68.75V13.75H82.5V27.5ZM110 110H96.25V96.25H110V110ZM110 82.5H96.25V68.75H110V82.5Z",
    fill: "#0F4C81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoEmpresarial);
export default __webpack_public_path__ + "static/media/GestaoEmpresarial.b6e23eb31910c5a65d973f2ba5b7589f.svg";
export { ForwardRef as ReactComponent };